import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from "../../../../shared/services/config.service";
import { UserService } from "../../../../shared/services/user.service";
import { Moment } from "moment";
import * as moment from "moment";
import { PlanOperationRequest, PlanOperationResourceRequest } from "../requests/plan-operation.request";

@Injectable({
  providedIn: 'root'
})
export class ProductionService {

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-production-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) { }

  // dynamiclayout

  getProduced(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.productionUrl + "/api/dynamiclayout/GetProduced", viewModel, this.httpOptions);
  }

  getCompleted(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.productionUrl + "/api/dynamiclayout/getcompleted", viewModel, this.httpOptions);
  }

  // productionsite

  getProductionSites(): Observable<any> {
    return this.http.get<any>(this.configService.config.productionUrl + "/api/productionsite/get", this.httpOptions);
  }

  // department

  getDepartments(): Observable<any> {
    return this.http.get<any>(this.configService.config.productionUrl + "/api/department/get", this.httpOptions);
  }

  // assignmentoperation

  getOperationNames(): Observable<any> {
    return this.http.get<any>(this.configService.config.productionUrl + "/api/assignmentoperation/getoperationnames", this.httpOptions);
  }

  // employee

  getEmployees(): Observable<any> {
    return this.http.get<any>(this.configService.config.productionUrl + "/api/employee/get", this.httpOptions);
  }

  // resource

  getResources(): Observable<any> {
    const companyId = this.userService.account.CompanyId;
    return this.http.get<any>(this.configService.config.productionUrl + "/api/resource/getbycompany?companyId=" + companyId.toString(), this.httpOptions);
  }

  // operation vm

  getOperationVm(): Observable<any> {
    return this.http.get<any>(`${this.configService.config.directUrl}/api/planning/getvmoperation?companyid=${this.userService.account.CompanyId}`, this.httpOptions);
  }

  // Production plan overview

  getProductionPlanOverviewsByDate(date: any, departmentIds: any, workGroupIds: any, selection: any): Observable<any> {
    let parameters = {
      date: date, departmentIds: departmentIds, workGroupIds: workGroupIds, selection: selection
    };
    return this.http.post<any>(this.configService.config.productionUrl + `/api/ProductionPlanOverview/GetProductionplanOverviewsByDate`, JSON.stringify(parameters), this.httpOptions);
  }
  getProductionPlanWeekOverviewsByDate(date: any, departmentIds: any, workGroupIds: any, selection: any): Observable<any> {
    let parameters = {
      date: date, departmentIds: departmentIds, workGroupIds: workGroupIds, selection: selection
    };
    return this.http.post<any>(this.configService.config.productionUrl + `/api/ProductionPlanOverview/GetProductionWeekPlansByDate`, JSON.stringify(parameters), this.httpOptions);
  }
  getProductionPlanMonthOverviewsByDate(date: any, departmentIds: any, workGroupIds: any, selection: any): Observable<any> {
    let parameters = {
      date: date, departmentIds: departmentIds, workGroupIds: workGroupIds, selection: selection
    };
    return this.http.post<any>(this.configService.config.productionUrl + `/api/ProductionPlanOverview/GetProductionMonthPlansByDate`, JSON.stringify(parameters), this.httpOptions);
  }

  getWorkGroups(): Observable<any> {
    return this.http.get<any>(this.configService.config.productionUrl + `/api/WorkGroup/Get`, this.httpOptions);
  }

  getWeekPlans(): Observable<any> {
    return this.http.get<any>(this.configService.config.productionUrl + `/api/ProductionWeekPlans/Get`, this.httpOptions);
  }

  getDayPlans(): Observable<any> {
    return this.http.get<any>(this.configService.config.productionUrl + `/api/ProductionDayPlans/Get`, this.httpOptions);
  }

  putResourceCapacity(rec: any): Observable<any> {
    return this.http.put<any>(this.configService.config.productionUrl + '/api/ProductionPlanOverview/PutResourceCapacity', rec, this.httpOptions);
  }

  getConnectableEmployeeResourcesByJob(operationResourceId: number): Observable<any> {
    const params = `?operationresourceid=${operationResourceId}`;
    return this.http.get<any>(`${this.configService.config.productionUrl}/api/connectableemployeeresources/getbyjob${params}`, this.httpOptions);
  }

  getOrderlinesToConfirmDeliveryDate(fromDate: Moment, toDate: Moment): Observable<any[]> {
    const params = `?fromDate=${encodeURIComponent(fromDate.format("YYYY-MM-DD"))}&toDate=${encodeURIComponent(toDate.format("YYYY-MM-DD HH:mm:ss"))}`;

    return this.http.get<any>(`${this.configService.config.productionUrl}/api/dynamiclayout/getorderlinestoconfirmdeliverydate${params}`, this.httpOptions);
  }

  getAssignmentsToPlan(): Observable<any[]> {
    return this.http.get<any>(`${this.configService.config.productionUrl}/api/dynamiclayout/getassignmentstoplan`, this.httpOptions);
  }

  planOperation(request: PlanOperationRequest) {
    return this.http.post<any>(this.configService.config.productionUrl + '/api/manualplanning/planoperation', request, this.httpOptions);
  }

  planInsertAndRemoveOperation(requests: PlanOperationResourceRequest[]) {
    return this.http.post<any>(this.configService.config.productionUrl + '/api/manualplanning/planinsertandremoveoperation', requests, this.httpOptions);
  }
}
